import React from "react";
import useStyles from "../common/Styles";
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

const CitiesMetrics = () => {
  const classes = useStyles();
  const { city_metrics, chart_selected } = useSelector(
    (state) => state.water_user
  );
  const metrics = [
    [
      {
        label: "Customer taps",
        value: `${Math.round(city_metrics.tap_num).toLocaleString("en-US")} acre-feet (${Math.round(
          city_metrics.tap * 100
        )}%)`,
      },
      {
        label: "Aquifer recharge",
        value: `${Math.round(
          city_metrics.aquifer_recharge_num
        ).toLocaleString("en-US")} acre-feet (${Math.round(city_metrics.aquifer_recharge * 100)}%)`,
      },
      {
        label: "Turf (golf, schools, parks, HOAs, cemeteries, other)",
        value: `${Math.round(city_metrics.turf_num).toLocaleString("en-US")} acre-feet (${Math.round(
          city_metrics.turf * 100
        )}%)`,
      },
    ],
    [
      {
        label: "Customer taps",
        value: `${Math.round(
          city_metrics.tap_colorado_num
        ).toLocaleString("en-US")} acre-feet (${Math.round(city_metrics.tap_colorado_percent * 100)}%)`,
      },
      {
        label: "Aquifer recharge",
        value: `${Math.round(
          city_metrics.aquifer_recharge_colorado_num
        ).toLocaleString("en-US")} acre-feet (${Math.round(
          city_metrics.aquifer_recharge_colorado_percent * 100
        )}%)`,
      },
      {
        label: "Turf (golf, schools, parks, HOAs, cemeteries, other)",
        value: `${Math.round(
          city_metrics.turf_colorado_num
        ).toLocaleString("en-US")} acre-feet (${Math.round(
          city_metrics.turf_colorado_percent * 100
        )}%)`,
      },
    ],
  ];

  // const metricTitle = {
  //   label: `${city_selected.name}: Use of Colorado River Water`,
  //   value: `${Math.round(city_metrics.percent_colorado * 100)}%`,
  // };

  return (
    <Grid item xs={12} className={classes.aboutBox}>
      {chart_selected === 1 ? (
        <>
          <Typography
            variant="body2"
            component="p"
            className={classes.metricCaption}
            style={{ fontSize: 18}}          
          >
            How the city uses all water supplies
          </Typography>
          {metrics[0].map((metric) => (
            <>
              <Typography
                variant="body2"
                component="p"
                className={classes.metricTitle}
              >
                {metric.label}
              </Typography>
              <Typography
                variant="h6"
                component="div"
                className={classes.metricValue}
              >
                {metric.value}
              </Typography>
            </>
          ))}
        </>
      ) : (
        <>
          <Typography
            variant="body2"
            component="p"
            className={classes.metricCaption}
            style={{ fontSize: 18}}
          >
            How the city uses water
          </Typography>
          {metrics[1].map((metric) => (
            <>
              <Typography
                variant="body2"
                component="p"
                className={classes.metricTitle}
              >
                {metric.label}
              </Typography>
              <Typography
                variant="h6"
                component="div"
                className={classes.metricValue}
              >
                {metric.value}
              </Typography>
            </>
          ))}
        </>
      )}
    </Grid>
  );
};

export default CitiesMetrics;
